__webpack_require__.p = "https://dev-reward.bp.com/";